import { Injectable } from '@angular/core';
import { Purpose } from '../models/new/purpose';

@Injectable({
	providedIn: 'root'
})
export class PurposeMapper {
	constructor() {}

	toPurpose(purpose: any) {
		return new Purpose({
			id: purpose.id,
			name: purpose.name
		});
	}
}
